import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad0ac1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('인기 1:1 거래 회사는?'))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 내 예산에 맞는 조합원 자격 매물들을 찾아보세요 ")
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_popular_share_transaction_modal = _resolveComponent("popular-share-transaction-modal")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        m: "40px 20px 40px 20px",
        dp: "flex",
        direction: "column"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s, { mb: "15px" }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                dp: "block",
                mr: "3px",
                typography: "tit24b"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {
            typography:'text14r',
            color:'#5E6068',
          } }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s, { css: {
          bg: 'bg1',
          borderRadius: '4px',
          p: 8,
          typography:'main12r',
          color:'gray3',
          my:20,
        } }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box_s, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`* ${_ctx.formattedDate(_ctx.updateDate)} 기준 거래량순`), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString('* 가격은 참고용으로 실제 거래가격과 차이가 있을 수 있습니다.'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakeList, (stake) => {
            return (_openBlock(), _createBlock(_component_ag_box_s, {
              key: stake.stockItemId,
              css: {
          dp: '20px', borderBottom:'1px solid #F9F9FB', mb: '15px',
          pb: '15px', dp: 'flex', alignItems:'center', dd:'row',
          justifyContent: 'space-between',
        },
              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'인기 1:1 거래 회사는?', 'clickContent':stake.stockItemName});_ctx.$emit('companyClick', stake.stockItemId)}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {width:50} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {
              width: '44px !important',
              height: '44px !important',
              position: 'relative',
            } }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "img-circle img-responsive",
                          src: stake.companyLogo ? stake.companyLogo : '/assets/icon/company_default_img.png',
                          onerror: "this.src='/assets/icon/company_default_img.png'",
                          style: {"flex-shrink":"0"}
                        }, null, 8, _hoisted_3),
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ag_box_s, { css: {
            minWidth:'180px',
          } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {
              typography:'text17m',
            } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(stake.stockItemName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ag_box_s, { css: {
              typography:'text12r',
              color:'gray3',
              dp:'flex',
              dd:'row',
            } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, { css: {
                mr:'4px',
                width:'12px',
                height:'12px',
                lineHeight: '17px',
              } }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(stake.likeCount), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ag_text_s, { css: {
                mx:'4px',
                color:'bg2',
              } }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.numberToKorean(stake.sellAmount)) + "원 거래 ", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ag_box_s, {
                  css: {
            textAlign:'right',
            typography:'text14r',
            dp:'block',
            color: (Number(stake.sellCount)===0?'gray4':'black'),
            minWidth:'90px',
          }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {
              dp:'block'
            } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.currency(stake.minPrice)) + " 원 ", 1)
                      ]),
                      _: 2
                    }, 1024),
                    (stake.minPrice!=stake.maxPrice)
                      ? (_openBlock(), _createBlock(_component_ag_text_s, {
                          key: 0,
                          css: {
              dp:'block'
            }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" ~ " + _toDisplayString(_ctx.$filters.currency(stake.maxPrice)) + " 원 ", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["css"])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent add_btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'인기 1:1 거래 회사는?', 'clickContent':'더보기'});_ctx.$emit('btnClick')})
          }, [
            _hoisted_7,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ]),
          _createVNode(_component_popular_share_transaction_modal, {
            "model-value": _ctx.viewShareTransactionOpen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.viewShareTransactionOpen = value)
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}